// extracted by css-extract-rspack-plugin
export default {"form":"form-wd_jU0","fields":"fields-QZ86JK","field":"field-lpUdmc","additional":"additional-sh17Tb"};